import React from 'react'

import { Trash2, XCircle } from 'lucide-react'

interface ConfirmActionProps {
  confirmLabel: string
  onCancel: () => void
  onConfirm: () => void
  prompt: string
}

export const ConfirmAction: React.FC<ConfirmActionProps> = ({ confirmLabel, onCancel, onConfirm, prompt }) => {
  return (
    <div aria-label={prompt} className="w-100 d-flex align-items-center" role="group">
      <span className="mr-auto">{prompt}</span>
      <button autoFocus className="btn btn-ghost" type="button" onClick={onCancel}>
        Keep
      </button>
      <button className="btn btn-danger ml-1" type="button" onClick={onConfirm}>
        {confirmLabel}
      </button>
    </div>
  )
}

interface DangerButtonProps {
  children: string
  disabled?: boolean
  icon?: 'trash' | 'cancel'
  onClick: () => void
  tabIndex?: number
}

export const DangerButton = React.forwardRef<HTMLButtonElement, DangerButtonProps>(
  ({ children, disabled, icon = 'trash', onClick, tabIndex }, ref) => {
    const Icon = icon === 'cancel' ? XCircle : Trash2

    return (
      <button
        ref={ref}
        className="btn btn-danger-ghost"
        disabled={disabled}
        tabIndex={tabIndex}
        type="button"
        onClick={onClick}
      >
        <Icon size={16} strokeWidth={1.75} />
        {children}
      </button>
    )
  },
)

DangerButton.displayName = 'DangerButton'
